import { render, staticRenderFns } from "./FilesPage.vue?vue&type=template&id=46ba0eb4&scoped=true"
import script from "./FilesPage.vue?vue&type=script&lang=js"
export * from "./FilesPage.vue?vue&type=script&lang=js"
import style0 from "./FilesPage.vue?vue&type=style&index=0&id=46ba0eb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ba0eb4",
  null
  
)

export default component.exports